import { render, staticRenderFns } from "./CompGeneralSlider.vue?vue&type=template&id=0743dbed&scoped=true"
import script from "./CompGeneralSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGeneralSlider.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompGeneralSlider.vue?vue&type=style&index=0&id=0743dbed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0743dbed",
  null
  
)

export default component.exports